import { render, staticRenderFns } from "./NewsCard.vue?vue&type=template&id=fecf79e0&scoped=true&"
import script from "./NewsCard.vue?vue&type=script&lang=js&"
export * from "./NewsCard.vue?vue&type=script&lang=js&"
import style0 from "./NewsCard.vue?vue&type=style&index=0&id=fecf79e0&scoped=true&lang=css&"
import style1 from "./NewsCard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fecf79e0",
  null
  
)

export default component.exports